export const servicesData = [
  {
    id: 1,
    title: 'Reality Check',
    introText:
      'Första steget i rätt riktning för att jobba mer jämställt är att vi tillsammans gör en inventering av var på jämställdhetsskalan ert företag befinner sig i dagsläget.',
    img: './service-images/reality-check.jpg',
    linkTo: '/reality-check'
  },
  {
    id: 2,
    title: 'Action Plan',
    introText:
      'Vi tittar på det långsiktiga arbetet när det kommer till jämställdhet på ert företag.',
    img: './service-images/action-plan.jpg',
    linkTo: '/action-plan'
  },
  {
    id: 3,
    title: 'Rekrytering',
    introText:
      'Vårt mål är att bidra till en mer jämställd arbetsmarknad där ni som företag får den kompetens ni behöver och kvinnor kan garanteras en arbetsplats som känns respektfull, härlig och inkluderande.',
    img: './service-images/rekrytering.jpg',
    linkTo: '/rekrytering'
  },
  {
    id: 4,
    title: 'Jämställdhetspolicy',
    introText:
      'Hur säkerställer ni att ni jobbar jämställt och inkluderande för alla på bolaget?',
    img: './service-images/jamstalldhetspolicy.jpg',
    linkTo: '/jamstalldhetspolicy'
  },
  {
    id: 5,
    title: 'Skapa annonser',
    introText:
      'Att skapa en attraktiv annons som upplevs relevant i både färg, bild och text är oerhört viktigt för att nå de kvinnor som ni letar efter.',
    img: './service-images/skapa-annonser.jpg',
    linkTo: '/skapa-annonser'
  },
  {
    id: 6,
    title: 'Föreläsningar',
    introText:
      'Jämställdhet är inte enbart en fråga för kvinnor, vi vill därför nå ut till alla era medarbetare för att prata mer om vikten och innebörden av att få in jämställdhetsarbetet på en daglig basis och att det är något alla på företaget aktivt behöver jobba med.',
    img: './service-images/forelasning.jpg',
    linkTo: '/forelasningar'
  },
  {
    id: 7,
    title: 'Workshops',
    introText:
      'Vems jobb är det egentligen att se till att ert team är jämställt? Svaret är att det ansvaret såklart inte ligger på en enskild individs axlar utan det är ett gemensamt arbete som alla i teamet behöver vara medvetna om och engagera sig i.',
    img: './service-images/workshops.jpg',
    linkTo: '/workshops'
  },
  {
    id: 8,
    title: 'Inkluderande ledarskap',
    introText:
      'Hur skapar man och behåller ett välkomnande klimat för sina kvinnliga anställda?',
    img: './service-images/inkluderande-ledarskap.jpg',
    linkTo: '/ledarskap'
  }
];
